import React, { Component } from 'react';
import './ProductInfo.css'
export default class ProductInfo extends Component {
  static defaultProps={
    fundName:'--',
    valDate:'--',
    valName:'--',
    val:'--',
    rate:'--',
    rateName:'--'
  }
  constructor(props) {
    super(props);
    this.state = {

    };
  }
  componentWillMount(){
    
  }
  onClick(){
    if (this.props.singlePoint) {
      this.props.singlePoint()
    } 
  }
  render(){
    let color=['#fa063a','#009AA6']
    return (
        <div className="pro-info" onClick={()=>this.onClick()}>
          <div className='pro-info-top'>
            <div className='pro-info-top-text1'>
              {this.props.fundName}
            </div>
            <div className='pro-info-top-text2'>

            </div>
          </div>
          <div className='pro-info-bottom'>
            <div className='pro-info-bottom-text1'>
              <p>{this.props.valName}:<span>{this.props.val}</span>{`(${this.props.valDate})`}</p>
            </div>
            <div className='pro-info-bottom-text2'>
              <p>{this.props.rateName}:<span style={this.props.rate=='--'||this.props.rate-0>=0?{color:color[0]}:{color:color[1]}}>{this.props.rate}%</span></p>
            </div>
          </div>
        </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/product/component/ProductInfo.js